import React, { useState, useEffect } from "react";
import { List, Modal, notification, Image } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios"; // <- using axios
import { DragHandle } from "../../../../components/DragHandle";

const Ordering = ({
  isOpen,
  onClose,
  datas,
  moduleName,
  isMobile,
  image_url,
  base_url,
  sectionId,
}) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);

  // -----------------------------
  // Log incoming data
  // -----------------------------
  useEffect(() => {
    setDatalist(datas || []);
  }, [datas, sectionId]);

  // -----------------------------
  // Handle reorder save
  // -----------------------------
  const handleOrder = async () => {
    try {
      setLoading(true);

      // Prepare IDs
      const orderedItemIds = datalist.map((item) => {
        return item._id.toString();
      });

      const payload = { sectionId, orderedItemIds };

      // Use axios to send POST request
      const { data } = await axios.post(`${base_url}reorderHosLife`, payload);

      if (data && data.data) {
        notification.success({
          message: `${moduleName} order updated successfully`,
        });

        if (onClose) onClose(data.data); // send updated list to parent
        setDatalist(data.data); // update modal list
      } else {
        console.warn("⚠️ No data returned from backend");
      }
    } catch (err) {
      console.error("❌ Error updating order:", err.response || err);
      notification.error({ message: "Failed to update order" });
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------
  // Handle drag & drop
  // -----------------------------
  const onDragEnd = (result) => {

    if (!result.destination) {
      console.warn("⚠️ Dropped outside list");
      return;
    }

    const srcIndex = result.source.index;
    const destIndex = result.destination.index;

    const temp = Array.from(datalist);
    const [moved] = temp.splice(srcIndex, 1);
    temp.splice(destIndex, 0, moved);

    setDatalist(temp);
  };

  return (
    <Modal
      title="Ordering"
      visible={isOpen}
      onOk={handleOrder}
      okText="Update"
      confirmLoading={loading}
      onCancel={() => onClose()}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="hoslife-ordering">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ maxHeight: 400, overflow: "auto" }}
            >
              <List
                bordered
                dataSource={datalist}
                renderItem={(item, index) => (
                  <Draggable
                    key={item._id.toString()}
                    draggableId={item._id.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef}>
                        <List.Item
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style,
                            boxShadow: snapshot.isDragging
                              ? "0 0 .4rem #666"
                              : "none",
                            display: "flex",
                            alignItems: "center",
                            gap: 16,
                          }}
                        >
                          <Image
                            width={isMobile ? 80 : 100}
                            src={image_url + item.mainImg}
                            fallback="https://via.placeholder.com/100"
                          />
                          <span>{item.thumb || "-"}</span>
                          <DragHandle {...provided.dragHandleProps} />
                        </List.Item>
                      </div>
                    )}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default Ordering;
